

export const HTTP = {

};

export const GAME_MODES = {
    SINGLE_PLAYER: 'single-player',
    MULTIPLAYER: 'multiplayer'
};

export const ERROR_MESSAGES = {
    GENERIC_ERROR: 'Ocorreu um erro. Tente novamente.',
    PLAYER_ALREADY_IN_ROOM: 'O utilizador já se encontra na sala.',
    ROOM_NOT_FOUND: 'A sala não existe.',
    ROOM_IS_FULL: 'A sala atingiu o limite máximo de jogadores.',
    GAME_ALREADY_RUNNING: 'Já existe um jogo a decorrer na sala.',
};
